import { useEffect, useRef, useState } from 'react';
import '../css/Consulta.css';
import { ValidarNum, ValidarNumLtrNS } from '../shared/Regex';
import Aviso, { mostrarAviso, ocultarAviso } from '../shared/Modules/Aviso';
import { v4 } from 'uuid';
import { registrarSolicitud } from '../shared/Functions/FuncionesAsync';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
export default function Consulta(){
    //#region STATE
    const[rucEmisor, setRucEmisor] = useState('');
    const[tipoDoc, setTipoDoc] = useState('01');
    const[serie, setSerie] = useState('');
    const[correlativo, setCorrelativo] = useState('');
    const[docCliente, setDocCliente] = useState('');

    const[indicadorCargaSolicitud, setIndicadorCargaSolicitud] = useState(false);

    const[datosCompletos, setDatosCompletos] = useState(false);
    const[bloqueoCaptcha, setBloqueoCaptcha] = useState(true);

    //ESTADOS PARA MANEJAR AVISOS
    const[contenedorAviso, setContenedorAviso] = useState(<></>);
    //#endregion

    //#region EFFECT
    useEffect(()=>{
        validarConsultaAnterior();
    },[]);

    useEffect(()=>{
        try{
            if(rucEmisor.length != 11 || serie.length != 4 || correlativo.length != 7){
                throw new Error();
            }
            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[rucEmisor, serie, correlativo]);
    //#endregion

    //#region NAVIGATE
    const navigate = useNavigate();
    //#endregion

    //#region REF
    const vCaptcha = useRef(null);
    //#endregion

    //#region  HANDLERS
    const HandlerRucEmisor = (valor) => {
        if(ValidarNum(valor) || valor == ''){
            setRucEmisor(valor);
        }
    }
    const HandlerTipoDoc = (valor) => {
        setTipoDoc(valor);
    }
    const HandlerSerie = (valor) => {
        if(ValidarNumLtrNS(valor) || valor == ''){
            setSerie(valor.toUpperCase());
        }
    }
    const HandlerCorrelativo = (valor) => {
        if(ValidarNum(valor) || valor == ''){
            if(valor == '00000000' || valor == '000000'){
                setCorrelativo('');
            }else{
                if(valor != ''){
                    setCorrelativo(Number.parseInt(valor.slice(-7)).toString().padStart(7,'0'));
                }else{
                    setCorrelativo('');
                }
            }
        }
    }
    const HandlerDocCliente = (valor) => {
        if(ValidarNum(valor) || valor == ''){
            setDocCliente(valor);
        }
    }

    const HandlerIndicadorCargaSolicitud = (valor) => setIndicadorCargaSolicitud(valor);

    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    const HandlerBloqueoCaptcha = (valor) => setBloqueoCaptcha(valor);
    //#endregion

    //#region  FUNCIONES
    const generarUUID = () => {
        const codigo = v4();
        return codigo;
    }
    const validarConsultaAnterior = () => {
        if(localStorage.getItem("cod") && localStorage.getItem("cod") != ""){
            navigate("/comprobante");
        }
    }
    //FUNCIONES PARA AVISOS
    const avisoError = (mensaje, tiempo) => {
        setContenedorAviso(<><Aviso mensaje={mensaje} tipo={'d'}/></>);
        setTimeout(() => {
            mostrarAviso();
            setTimeout(() => {
                ocultarAviso();
            }, tiempo);
        }, 10);
    }

    //FUNCIÓN REGISTRO DE SOLICITUD
    const generarSolicitud = async () => {
        HandlerIndicadorCargaSolicitud(true);
        
        const codigoSolicitud = generarUUID();
        const solicitud = {
            codigo: codigoSolicitud,
            emisor: rucEmisor,
            tipoComprobante: tipoDoc,
            serie: serie,
            correlativo: correlativo,
            docCliente: docCliente,
            fecha: new Date()
        }

        let registrado = await registrarSolicitud(solicitud);
        if(registrado == true){
            localStorage.setItem("cod", codigoSolicitud);
            setTimeout(()=>{
                navigate("/comprobante");
            },3000);
        }
    }

    // FUNCIÓN RECAPTCHA
    const onChange = () => {
        if(vCaptcha.current.getValue()){
            HandlerBloqueoCaptcha(false);
        }
    }
    //#endregion

    const enviarConsulta = async () => {
        try{
            if(!ValidarNum(rucEmisor) || rucEmisor.length != 11){
                document.querySelector('#ruc-emisor').focus();
                HandlerRucEmisor('');
                throw new Error('El formato del RUC del emisor no es válido');
            }
            if(serie.length != 4){
                document.querySelector('#serie-documento').focus();
                HandlerSerie('');
                throw new Error('El formato de la serie del documento no es válido');
            }
            if(correlativo.length != 7){
                document.querySelector('#correlativo-documento').focus();
                HandlerCorrelativo('');
                throw new Error('El formato del número correlativo del documento no es válido');
            }
            // if(docCliente.length != 8 && docCliente.length != 11){
            //     document.querySelector('#documento-cliente').focus();
            //     HandlerDocCliente('');
            //     throw new Error('El formato del documento del cliente no es válido');
            // }

            await generarSolicitud();
        }catch(ex){
            avisoError(ex.message, 2500);
        }
    }
    //#region CONTENIDO
    return(<>
    {contenedorAviso}
    <div className='container' data-bs-theme='dark'>
        <div className='row p-0'>
            <div className='d-flex justify-content-center align-items-center contenedor-formulario'>
                <div className='formulario-consulta'>
                    <div className='py-3 d-flex justify-content-center'>
                        <img src="/logo-h.png" alt="Power Group System" width={'70%'}/>
                    </div>
                    <div className='p-2'>
                        <div className='form-floating'>
                            <input onChange={e=>HandlerRucEmisor(e.target.value)} value={rucEmisor} id='ruc-emisor' maxLength={11} type="text" className='form-control' placeholder='N° RUC del emisor' autoComplete='off'/>
                            <label className='text-secondary' htmlFor="ruc-emisor">N° RUC del emisor</label>
                        </div>
                    </div>
                    <div className='p-2'>
                        <div className='form-floating'>
                            <select onChange={e=>HandlerTipoDoc(e.target.value)} value={tipoDoc} id="tipo-documento" className='form-select' placeholder='Tipo de Comprobante'>
                                <option value="01">Factura</option>
                                <option value="03">Boleta de Venta</option>
                                <option value="07">Nota de Crédito</option>
                            </select>
                            <label className='text-secondary' htmlFor="tipo-documento">Tipo de Comprobante</label>
                        </div>
                    </div>
                    <div className='row px-2'>
                        <div className='col-5 py-2'>
                            <div className='form-floating'>
                                <input onChange={e=>HandlerSerie(e.target.value)} value={serie} id='serie-documento' maxLength={4} type="text" className='form-control' placeholder='Serie' autoComplete='off'/>
                                <label className='text-secondary' htmlFor="serie-documento">Serie</label>
                            </div>
                        </div>
                        <div className='col-1 p-2 text-secondary fs-2 text-center'>-</div>
                        <div className='col-6 py-2'>
                            <div className='form-floating'>
                                <input onChange={e=>HandlerCorrelativo(e.target.value)} value={correlativo} id='correlativo-documento' maxLength={8} type="text" className='form-control' placeholder='Correlativo' autoComplete='off'/>
                                <label className='text-secondary' htmlFor="correlativo-documento">Correlativo</label>
                            </div>
                        </div>
                    </div>
                    {/* <div className='p-2'>
                        <div className='form-floating'>
                            <input onChange={e=>HandlerDocCliente(e.target.value)} value={docCliente} id='documento-cliente' maxLength={11} type="text" className='form-control' placeholder='Documento del Cliente' autoComplete='off'/>
                            <label className='text-secondary' htmlFor="documento-cliente">Documento del Cliente</label>
                        </div>
                    </div> */}
                    <div className={datosCompletos ? 'py-3 d-flex justify-content-center' : 'py-3 d-flex justify-content-center d-none'}>
                        <ReCAPTCHA 
                        ref={vCaptcha}
                        sitekey="6LfqeZ0qAAAAAPhdE_BJaULTs9k5BfFcBUqnGkSx"
                        onChange={onChange} 
                        theme='dark'/>
                    </div>
                    <div className={bloqueoCaptcha ? 'py-3 d-flex justify-content-center d-none' : 'py-3 d-flex justify-content-center'}>
                        <button disabled={indicadorCargaSolicitud} onClick={enviarConsulta} className='btn btn-primary px-4'>
                            { 
                                indicadorCargaSolicitud ? (<>
                                <span className='mx-2'>Consultando</span>
                                <span>
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </span>
                                </>):(<>
                                <span className='mx-2'>Consultar Comprobante</span>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                                    </svg>
                                </span>
                                </>)
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>);
    //#endregion
}